module.exports = __webpack_public_path__ + "r-v3/img/pentagon.60b5f0bf.svg";